import { useTheme } from "@mui/material";
import {
	useGoalsRightOptional,
	usePortfolioRightOptional,
} from "web_myplann/Api/Rights/RightsProvider";

export const useFlatRowValueColor = (): string => {
	const { palette } = useTheme();
	const hasGoalsRight = useGoalsRightOptional();
	const { hasRight: hasPortfolioRight } = usePortfolioRightOptional();

	return hasGoalsRight || hasPortfolioRight
		? palette.grey[900]
		: palette.blue[600];
};
